import { render } from "./ViewTicket.vue?vue&type=template&id=b27c8cc8&scoped=true"
import script from "./ViewTicket.vue?vue&type=script&lang=js"
export * from "./ViewTicket.vue?vue&type=script&lang=js"

import "./ViewTicket.vue?vue&type=style&index=0&id=b27c8cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27c8cc8"]])

export default __exports__